import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage' | 'BreadcrumbList';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();

  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  if (type === 'WebPage' || type === 'Article' || type === 'FAQPage') {
    (baseSchema as Record<string, unknown>).url = `https://hnatawindow.cn${location.pathname}`;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(baseSchema, null, 2) }}
    />
  );
}